import React, { useContext, useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';
import { useSearchBox } from 'react-instantsearch-hooks-web';
import HraderDeliveryAddress from '../DTC/bento/HraderDeliveryAddress';
import appContext from '../../Context/appContext';
import HiddenFilter from './HiddenFilter';
import FilterButton from './FilterButton';
import { popNotification } from '../../redux/slices/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setResultState, setSearchState, setSelectedPriceSort } from '../../redux/slices/searchSlice';

const SearchInput = ({ currentTab, storeRecentSearch, toggleFilterPopup, filterApplied }) => {
  // const {
  //   state: {
  //     search: { searchQuery }
  //   }
  // } = useContext(appContext);

  const searchQuery = useSelector(state => state.search.searchQuery)

  const searchRef = useRef(null);

  return (
    <div ref={searchRef} className=" new-search-component input-group searchBar">
      <HraderDeliveryAddress />
      <div className="d-flex align-items-center w-100 pb-1 pb-lg-0">
        <CustomSearchBox storeRecentSearch={storeRecentSearch} />
        <HiddenFilter currentTab={currentTab} />
        {/* //Add facets to dashboard and uncomment this */}
        {searchQuery ? <FilterButton toggleFilterPopup={toggleFilterPopup} filterApplied={filterApplied} /> : null}
      </div>
    </div>
  );
};
const queryHook = debounce(
  (query, search) => {
    search(query?.trim());
  },
  300,
  { leading: false, trailing: true }
);

export function CustomSearchBox({ storeRecentSearch, className = false, isSearchtab }) {
  // const {
  //   // state: {
  //   //   search: { searchQuery }
  //   // },
  //   dispatch
  // } = useContext(appContext);

  const searchQuery = useSelector(state => state.search.searchQuery)

  const dispatchRedux = useDispatch()

  const inputRef = useRef(null);

  const { query, refine, clear } = useSearchBox({ queryHook });
  const onSearchStateChange = event => {
    const value = event?.target?.value;
    const sanitizedValue = value?.replace(/[^a-zA-Z0-9 ]/g, '');
    // dispatch({ type: 'setSearchState', payload: sanitizedValue });
    dispatchRedux(setSearchState(sanitizedValue))
    dispatchRedux(popNotification())

  };
  useEffect(() => {
    refine(searchQuery);
    if (!searchQuery) {
      // dispatch({ type: 'setResultState', payload: '' });
      dispatchRedux(setResultState(''))
      // dispatch({ type: 'setSelectedPriceSort', payload: '' });
      dispatchRedux(setSelectedPriceSort(''))
      window.scrollTo(0, 0);
    }
  }, [searchQuery]);

  const onClearSearch = () => {
    window.scrollTo(0, 0);
    // dispatch({ type: 'setSearchState', payload: '' });
    dispatchRedux(setSearchState(''))
    clear();
    inputRef.current.focus();
  };

  return (
    <div className={`search-page-bar  position-relative mb-0 ${className || `searchp-section`}`}>
      <button type="button" className="btn search-btn ">
        <i className="icon-search" />
      </button>
      <input
        type="text"
        value={searchQuery}
        onChange={onSearchStateChange}
        placeholder='Try "Indica" or "Hybrid"'
        autoFocus
        onBlur={storeRecentSearch}
        className="main-search-input"
        ref={inputRef}
      />
      {searchQuery ? (
        <button type="button" onClick={onClearSearch} className="btn search-close-btn ">
          <i className="icon-close" />
        </button>
      ) : null}
    </div>
  );
}

export default SearchInput;
